// extracted by mini-css-extract-plugin
module.exports = {"app":"bh_c1","appTitle":"bh_c2","bigCard":"bh_gC","appSubtitle":"bh_gD","appSubtitle_dark":"bh_gF","iconContent":"bh_gG","bigIcon":"bh_gH"};